export default "__VITE_ASSET__C8kQh5T7__"